import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { INLINES, BLOCKS } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { getProperParagraphOrSpace, embeddedAssetBlockAsImg, getProperListItem, getProperList, getInternalLink } from './HTMLParserOptions';
import { removeEmptyParagraphAfterList } from './RemoveEmptyParagraph';
import { UseGetRichTextStyle } from '~/composables/useGetRichTextStyle';
export var useParseDocumentToHtml = function useParseDocumentToHtml(document) {
  var displayOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var customRenderer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var links = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var options = {
    renderNode: _objectSpread(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BLOCKS.EMBEDDED_ASSET, function (node) {
      return embeddedAssetBlockAsImg(node);
    }), "paragraph", function paragraph(node, next) {
      return getProperParagraphOrSpace(node, next);
    }), BLOCKS.LIST_ITEM, function (node, next) {
      return getProperListItem(displayOptions, node, next);
    }), BLOCKS.UL_LIST, function (node, next) {
      return getProperList(displayOptions, node, next);
    }), INLINES.ENTRY_HYPERLINK, function (node, next) {
      return getInternalLink(node, next, links, locale);
    }), customRenderer.renderNode),
    renderMark: _objectSpread({
      bold: function bold(text) {
        return "<b class=\"".concat(UseGetRichTextStyle(displayOptions), "\">").concat(text, "</b>");
      },
      underline: function underline(text) {
        return "<u class=\"".concat(UseGetRichTextStyle(displayOptions), "\">").concat(text, "</u>");
      }
    }, customRenderer.renderMark)
  };
  var html = ref('');
  function doParse() {
    var documentUnref = unref(document);
    if (!documentUnref) {
      html.value = '';
      return;
    }
    var parsedDocument = removeEmptyParagraphAfterList(documentUnref);
    var rawHtml = documentToHtmlString(parsedDocument, options);
    // Remove tags with empty value and space(exept table tags)
    html.value = rawHtml.replace(/(<(?!\/)(?!table)(?!tbody)(?!th)(?!tr)(?!td)[^>]+>)+[ \n(<br>)\W]*(<\/(?!table)(?!tbody)(?!th)(?!tr)(?!td)[^>]+>)+/g, '');
  }
  var documentRef = computed(function () {
    return isRef(document) ? document.value : document;
  });
  watch(documentRef, doParse, {
    immediate: true
  });
  return {
    html: html
  };
};